<template>
    <div v-html="html"></div>
</template>

<script>
    export default {
        name: "delivery-calc",
        data () {
            return {
                cost: '',
                html: '',
            }
        },
        methods: {
            get_cost: function () {
                this.$store.commit('setLoading', true)
                try {
                    let params = new URLSearchParams();
                    params.append('action', 'get_deliv_cost');
                    axios
                        .get('/rest/spec', {params})
                        .then((response) => {

                            this.html = response.data

                            this.$store.commit('setLoading', false)
                        })
                } catch(error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            }
        },
        mounted() {
            this.get_cost();
        },
        created() {
            Evnt.listen('SomethingChangedInCart', () => {console.log('event changProductQty');this.get_cost()})
        },
    }
</script>

<style scoped>

</style>